import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSportById } from 'entities/sport';
import { ISportCellProps } from './sport-cell.types';

export const SportCell: FC<ISportCellProps> = ({ sportId }) => {
  const { i18n } = useTranslation();
  const sport = useSportById(sportId);

  const localizedSportName =
    sport?.translations?.find(tr => tr.langCode === i18n.language) ||
    sport?.name;

  return <>{localizedSportName ? localizedSportName : sportId}</>;
};
